import { useState } from 'react';
import Roles from "./Role/Roles";
import Role from "./Role/Role";
import Permissions from './Permissions';
import PermissionsRole from './PermissionsRole';
import Matriz from './Matriz';

const PermissionPrincipal = (props) => {
  const [loading, setLoading] = useState(false)
   const params = {
    message: props.message,
    logout: props.logout,
    setLoading
  }
  const isEditor = props.permissions.includes(17);
  const permissions = Permissions(params)
  const matriz = Matriz(params)

  const roles = Roles({
    ...params,
    isEditor,
    losesAccess: props.losesAccess
  })
  
  const permissionsRole = PermissionsRole({
    ...params,
    losesAccess: props.losesAccess,
    role: roles.selectedRole,
    setRole: roles.setSelectedRole
  })

  const role = Role({
    ...params,
    loading,
    isEditor,
    setRole: roles.setRole,
    setRoles: roles.setRoles,
    setPermissionsRoles: permissionsRole.setPermissionsRoles,
    selectedRole: roles.selectedRole,
    losesAccess: props.losesAccess
  })

  return {
    ...roles,
    ...role,
    ...permissionsRole,
    matriz,
    loading,
    isEditor,
    permissions
  };
};

export default PermissionPrincipal;
